// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"letters-z"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M7 5H15.4714C15.5267 5 15.5714 5.04477 15.5714 5.1V7.5L8 16.5V18.9C8 18.9552 8.04477 19 8.1 19H17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LettersZIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'letters-z',
    ref,
    icon: element,
  },
));

LettersZIcon.displayName = 'LettersZIcon';

export default LettersZIcon;
